module.exports = __webpack_public_path__ + "static/media/fundo-mapa-dark.ec7dfc99.jpg";